/*
 * Payment details: query params and request bodies, pinned to teacher_payment_details_ops_enums
 * (request_fields_read/required) by request_fields.test.js.
 */
import { trim_reason } from '../needs_attention/params';

export const PENDING_PAGE_SIZE = 50;
export const AWAITING_PAGE_SIZE = 100;

// after_id: the previous page's next_after_id (0 = first page; the server reads 0 as "from the start").
export const pending_params = (after_id, limit = PENDING_PAGE_SIZE) => ({
  after_id: after_id || 0,
  limit
});

export const view_params = (detail_uuid) => ({ detail_uuid });

export const ifsc_params = (ifsc) => ({ ifsc });

const MONTH_RE = /^20[0-9]{2}-(0[1-9]|1[0-2])$/;

// pay_month: the month the page shows, stamped on the review's audit row; left out when not a valid month.
const with_pay_month = (body, pay_month) =>
  typeof pay_month === 'string' && MONTH_RE.test(pay_month) ? { ...body, pay_month } : body;

export const approve_body = (detail_uuid, confirm_shared_account, pay_month) =>
  with_pay_month(
    { detail_uuid, confirm_shared_account: confirm_shared_account === true },
    pay_month
  );

export const reject_body = (detail_uuid, reason, pay_month) =>
  with_pay_month({ detail_uuid, reason: trim_reason(reason) }, pay_month);

export const history_params = (pay_month) => ({ pay_month });

// since_month '' = the server's default (the payouts cutover month); the query builder drops it.
export const awaiting_params = (since_month, after_teacher_id, limit = AWAITING_PAGE_SIZE) => ({
  since_month: since_month || '',
  after_teacher_id: after_teacher_id || 0,
  limit
});

// The full-details download reads no fields: always the whole pending queue.
export const export_params = () => ({});
